import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-back\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h20v20H0z\" /><g transform=\"translate(3 4)\"><rect width=\"14\" height=\"2\" x=\"1\" y=\"5\" fill=\"currentColor\" rx=\"1\" /><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M6 11.657.343 6 6 .343\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol